import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_AGENT_GET_LISTING_SHOWING_INFO,
} from 'api/actionTypes';

export default async function getListingShowingInfo({ state, apiClient }, listingId) {
  listingId = parseInt(listingId, 10);
  typeCheck('listingId::Number', listingId);

  await apiClient.postWithState({
    action: SR_API_ACTION_AGENT_GET_LISTING_SHOWING_INFO,
    payload: {
      listingId: listingId,
    },
    state: state,
    onSuccess(listingShowingInfo) {
      state.set(['agent', 'listingShowingInfo'], listingShowingInfo);
    },
  });
}
